import React from 'react';
import PropTypes from 'prop-types';
import { Select } from '@pitchero/react-ui';
import { concat } from 'lodash';
import { COMPETITIONS_PROP_TYPES } from '../../../lib/prop-types/competition';

const CompetitionFilter = ({ competitions, selected, onChange }) => {
  const defaultOption = [
    {
      value: '',
      name: 'All competitions',
      disabled: false,
    },
  ];

  const selectOptions = concat(
    defaultOption,
    competitions.map((competition) => ({
      value: competition.id,
      name: competition.name,
      disabled: false,
    })),
  );

  const disabled = selectOptions.length === 1;

  return (
    <Select
      options={selectOptions}
      onChange={onChange}
      disabled={disabled}
      value={selected || ''}
    />
  );
};

CompetitionFilter.defaultProps = {
  selected: '',
};

CompetitionFilter.propTypes = {
  onChange: PropTypes.func.isRequired,
  competitions: COMPETITIONS_PROP_TYPES.isRequired,
  selected: PropTypes.string,
};

export default CompetitionFilter;
